export default __webpack_public_path__ + "static/media/4_e-gds.eb45ca51.svg";